<template>
    <div class="skeleton-container flex flex-column">
        <ScaleLoader class="custom-loader" height="5rem" />
        <div class="flex flex-row justify-content-between my-2">
            <Skeleton size="15rem" />
            <Skeleton shape="circle" size="15rem" class="mr-2" />
            <Skeleton shape="circle" size="15rem" class="mr-2" />
            <Skeleton size="15rem" />
        </div>
        <div>
            <Skeleton height="10rem" class="mb-2"></Skeleton>
            <Skeleton height="10rem" class="mb-2"></Skeleton>
            <Skeleton height="10rem" class="mb-2"></Skeleton>
        </div>
    </div>
</template>